export default "__VITE_ASSET__CeuDc1Gm__"